export default __webpack_public_path__ + "static/media/209.ebcc072e.png";